import { Component } from '@angular/core';
import { DeviceInfoService } from '@site-shared/common';

@Component({
	selector: 'th-root',
	templateUrl: './app.component.html',
})
export class AppComponent {
	public readonly context: { title: string; subtitle: string } = {
		title: 'Регистрация',
		subtitle:
			'У Вас не получится зарегистрироваться с телефона или планшета. Мы рекомендуем пользоваться компьютером.',
	};

	constructor(public readonly deviceInfo: DeviceInfoService) {}
}
